import jwt_decode from "jwt-decode";

import { permissionList } from "../app-header/RheaSideNav/Permission";
import { getRolePermissionsList } from "./Login.service";

export async function handleLoginOnSuccess({
  response,
  setRedirectUrl,
  setFlag,
  setErrorMessage,
  setIsLoading,
  setIsErrorsVisible,
  product,
  history,
}) {
  if (response.statusCode >= 400) {
    setIsLoading(false);
    setIsErrorsVisible(true);
    setErrorMessage(response.message);
  }
  if (response.statusCode !== 200) return setIsLoading(false);
  let userRoles, rolePermissions, tempPermissions, rolePermObj, jwtToken, tenantId, tenantDetails;
  try {
    localStorage.setItem("isLoggedIn", true);
    localStorage.setItem("loginResponse", JSON.stringify(response));
    jwtToken = response?.object?.jwt;
    tenantDetails = JSON.stringify(response?.object?.tenantDetails);
    tenantId = jwt_decode?.(jwtToken)?.tenantID || "datafoundry";
    localStorage.setItem("tenantId", tenantId);
    localStorage.setItem("tenantDetails", tenantDetails);
    localStorage.setItem("applicationName", product || "msafety");
    userRoles = jwt_decode(jwtToken)?.userRoles || [];
    if (userRoles.length > 0) {
      rolePermissions = await getRolePermissionsList(userRoles.join(","));
    }
    tempPermissions = [];
    rolePermObj = { ...rolePermissions?.data?.responseObject };
  } catch (error) {
    //
  }
  fillTempPermissionsWithMatchingModuleName(tempPermissions, permissionList, rolePermObj);
  localStorage.setItem("permissions", JSON.stringify(tempPermissions || []));
  localStorage.setItem("rolePermissions", JSON.stringify(rolePermissions?.data?.responseObject || {}));
  if (history) {
    history.push("/dashboard");
  } else {
    setRedirectUrl(`/dashboard`);
  }
  setFlag(true);
}
export function fillTempPermissionsWithMatchingModuleName(tempPermissions, permissionList, rolePermObj = {}) {
  Object?.keys?.(rolePermObj).forEach?.((key) => {
    if (rolePermObj[key]) {
      const obj = permissionList.find((perm) => perm.moduleName === key);
      if (obj) {
        tempPermissions.push({ ...obj, visible: true });
      }
    }
  });
}
